import { Input } from '@arco-design/web-react';

interface InputRangeProps {
  value?: [string, string];
  onChange?: (value: [string, string]) => void;
}

export const InputRange = ({ value, onChange }: InputRangeProps) => {
  const [start, end] = value || [undefined, undefined];
  return (
    <div className="flex items-center gap-2">
      <Input
        value={start}
        allowClear
        onChange={(v: string) => {
          onChange?.([v, end || '']);
        }}
      />
      <span className="text-gray-500">~</span>
      <Input
        value={end}
        allowClear
        onChange={(v: string) => {
          onChange?.([start || '', v]);
        }}
      />
    </div>
  );
};
